import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import Layout from '../components/layout'
import { css } from "@emotion/core"
import '../styles/index.scss'
import tiendaStyles from '../styles/tiendaonline.module.scss'
import headerStyles from '../styles/header.module.scss'
import disenoStyles from '../styles/disenoweb.module.scss'

import { IoIosArrowRoundDown } from "react-icons/io";
import Metatags from '../components/metatag';

import socialCard from '../images/card.jpg'

// Video

import ShopifyVideo from "../assets/videoshopify.mp4"


// Iconos

import Pagoseguro from "../assets/pagoseguro.svg"
import Dashboard from "../assets/dashboard.svg"
import Responsive from "../assets/responsive-diseno.svg"
import Multilenguaje from "../assets/multilenguaje.svg"
import {FaCheck} from "react-icons/fa";
import {FaCheckCircle} from "react-icons/fa";
import Shopify from "../assets/shopify.svg"
import Webflow from "../assets/webflow.svg"
import Step1 from "../assets/step1.svg"
import Step2 from "../assets/step2.svg"
import Step3 from "../assets/step3.svg"

// Animaciones
import EcommerceHeader from "../components/animation/animation-ecommerce-header"

const IndexPage = () => {
    
    const data = useStaticQuery(graphql`
        query{
            site{
                siteMetadata{
                    title
                    description
                    siteUrl
                }
            }
            image2: file (relativePath: {eq: "portfolio.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            imageEcommerce: file (relativePath: {eq: "tienda-online.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            imageHeader: file (relativePath: {eq: "tienda-online-sevilla.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
        }
    
    `)

    return(
        <Layout>
            <Metatags
                title={`${data.site.siteMetadata.title} | Diseño de Tienda Online en Sevilla`}
                description="¿Necesitas una Tienda Online para vender tus productos o servicios? ✅ Diseño y desarrollo Tiendas Online en Sevilla que generan Resultados ¡☎ Llama al 680 719 745!"
                thumbnail={`${data.site.siteMetadata.siteUrl}${socialCard}`}
                url= {data.site.siteMetadata.siteUrl}
            />
            <section className={headerStyles.header_wrapper}>

                <div className={headerStyles.header_wrapper_left}>
                    <h1 className={headerStyles.header_wrapper_title}>Diseño de tienda online en Sevilla</h1>
                    <h2 className={headerStyles.header_wrapper_main}>Diseño y desarrollo de <span className={headerStyles.header_wrapper_main_highlight}>Tiendas online</span> para negocios
                    </h2>
                    <Link to='/diseno-tienda-online-sevilla#mas' className="btn btn__white btn__animated">Ver más</Link>
                </div>

                <div className={headerStyles.header_wrapper_right}>
                    <div className={headerStyles.header_wrapper_right_absolute}>
                        <Img fluid={data.imageHeader.childImageSharp.fluid} alt='Tienda online sevilla' />
                    </div>
                    
                </div>

            </section>
            <IoIosArrowRoundDown className={headerStyles.header_arrow} />
        

            <section className={tiendaStyles.intro} id="mas">
                <div className={tiendaStyles.intro_wrapper}>

                    <div className={tiendaStyles.intro_wrapper_up}>
                    
                        <h2 className={headerStyles.header_titles_text}>Convierte tu ecommerce en una máquina de ventas online<span className={headerStyles.header_titles_text_point}>.</span></h2>
                        <h3 className={headerStyles.header_titles_subtext}>Desarrollo de tienda online a medida.</h3>
                            <div className={tiendaStyles.intro_wrapper_up_box}>
                                <div className={tiendaStyles.intro_wrapper_up_box_left}>
                                    <p>Como diseñador web, desarrollo diseños de tiendas online en Sevilla <strong>¡Tus productos disponibles las 24 horas del día!</strong><br></br><br></br>
                                    Tu tienda online ayudará a escalar tu negocio, convirtiendo un negocio local en nacional o incluso internacional. Diseñaré la tienda online a medida que tu negocio necesita, donde tus clientes podrán adquirir tus productos o servicios de una forma segura.</p>

                                </div>

                                <div className={tiendaStyles.intro_wrapper_up_box_right}>
                                    <EcommerceHeader loading="lazy"/>
                                </div>
                            </div> 

                        <div className={tiendaStyles.intro_cta}>
                            <Link to='/contacto#schedule_form' className="btn_small btn_small__gold" css={css`@media (max-width:500px){padding: 0.75rem 1rem !important; letter-spacing: 0;}`}>Necesito asesoramiento gratuito</Link>
                        </div>
                        

                    </div>

                </div>
            </section>

            
            <section className={tiendaStyles.expertise}>
                <div className={tiendaStyles.expertise_wrapper_column}>

                    <div className={tiendaStyles.expertise_wrapper_column_top}>
                        <h2 className={headerStyles.header_titles_text}>Diseño de tiendas online en Sevilla<span className={headerStyles.header_titles_text_point}>.</span></h2>
                        <h3 className={headerStyles.header_titles_subtext}>Tu punto de venta en internet.</h3>
                        <p>Tanto si eres un negocio ya consolidado, como si eres un proyecto de tienda online, te ayudaré a conseguir tus objetivos de ventas. Marca la diferencia ofreciendo a tus clientes una experiencia de compra fácil y segura.</p>

                        <p>El objetivo es que tu cliente encuentre lo que busca y que ese proceso sea sencillo y en pocos pasos. De esta manera, la tasa de abandono será menor, y la conversión de venta aumentará.</p>
                    </div>
                    
                    <div className={disenoStyles.intro_wrapper_box}>
                        
                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Pagoseguro /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Pago Seguro</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Es esencial que el usuario que entre a tu tienda online, sienta confianza y seguridad a la hora de realizar el pago de su pedido.</p> 
                            <p className={headerStyles.header_titles_text_parrafo}>Tu tienda online, contará con las principales y más seguras pasarelas de pago del mercado como Paypal o Stripe que generan una gran confianza a los usuarios.</p>
                            <p className={headerStyles.header_titles_text_parrafo}>Además, instalaré un certificado SSL en tu dominio, para que todos los datos de tus clientes sean encriptados, y puedan realizar una compra segura.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>

                            <div className={disenoStyles.intro_wrapper_icon}><Dashboard /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Panel de control</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Un punto importante es la administración de la tienda online. Sólo tendrás que centrarte en la gestión de los pedidos de tu ecommerce.</p>
                            <p className={headerStyles.header_titles_text_parrafo}>Dispondrás de una tienda online autogestionable con un panel de control muy sencillo de usar, donde podrás gestionar todos los aspectos de tus pedidos, stock o precios entre muchos otros desde cualquier dispositivo, ya sea ordenador, tablet o móvil.</p>
                            
                                
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Responsive /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Diseño Responsive</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Es vital que tu tienda online tenga un diseño responsive (adaptado a todos los dispositivos).</p> 
                            <p className={headerStyles.header_titles_text_parrafo}>Según <a href="https://www.thinkwithgoogle.com/intl/es-es/recursos-y-herramientas/content-marketing-spain/desaf%C3%ADos-para-un-retail-m%C3%A1s-eficiente/" target="_blank" without rel="noopener noreferrer">Google</a> hasta un 63% de usuarios españoles encuestados que han comprado online, han realizado sus compras a través de su móvil. <br></br><br></br>Es por ello, que tu ecommerce estará adaptado a todos los dispositivos, ofreciendo todas las características y funcionalidades de tu tienda online por igual. </p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Multilenguaje /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Multilenguaje</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>¡Abre tu negocio al mundo! ¿Quieres vender tus productos en otros países? </p>
                            <p className={headerStyles.header_titles_text_parrafo}>Si es así, adaptaré tu tienda virtual a otros idiomas. Tu ecommerce estará disponoble en todas las lenguas que desees, cosa que te permitirá poder vender a clientes de otros países, y ampliar así tus oportunidades de negocio.</p>
                        </div>

                        <div className={tiendaStyles.intro_ctaTienda}>
                            <Link to='/contacto' className="btn_small btn_small__gold" css={css`@media (max-width:500px){padding: 0.75rem 1rem !important; letter-spacing: 0;}`}>Quiero mi tienda online</Link>
                        </div>
                        

                    </div>
                    
                    
                </div>
            </section>

            <section className={tiendaStyles.management}>
                <div className={tiendaStyles.management_wrapper_column}>

                    <div className={tiendaStyles.management_wrapper_column_top}>
                        <h2 className={headerStyles.header_titles_text_white}>Tiendas online auto gestionables<span className={headerStyles.header_titles_text_point}>.</span></h2>
                    </div>

                </div>

                <div className={tiendaStyles.management_wrapper}>
                    <div className={tiendaStyles.management_wrapper_title}>
                        <h3 className={headerStyles.header_titles_subtext}>Ten total control de tu tienda online desde cualquier sitio.</h3>
                    </div>
                    
                    <div className={tiendaStyles.management_wrapper_content}>

                        <div className={tiendaStyles.management_wrapper_left}>
                        
                            <p>Como experto en diseño de tiendas online en Sevilla, me adapto tanto a las necesidades de tu negocio como a tu presupuesto.</p>
                            <p>Podrás tener total control de tu tienda y hacer los cambios que necesites:</p>

                            <ul>
                                <li><span>Precios de los productos o servicios</span><FaCheck /></li>
                                <li><span>Modificar catálogo de productos o servicios</span><FaCheck /></li>
                                <li><span>Gestionar el stock</span><FaCheck /></li>
                                <li><span>Añadir o modificar imágenes de productos</span><FaCheck /></li>
                                <li><span>Gestionar el contenido de las descripciones</span><FaCheck /></li>
                                <li><span>Añadir ofertas y promociones</span><FaCheck /></li>
                                <li><span>Control de comentarios y review de productos</span><FaCheck /></li>
                            </ul>
                        </div>
                    
                        <div className={tiendaStyles.management_wrapper_right}>
                            <div className={tiendaStyles.management_wrapper_right_box}>

                                <div dangerouslySetInnerHTML={{ __html: `
                                    <video class="${tiendaStyles.management_wrapper_right_video}" playsinline loop autoPlay muted>
                                        <source src="${ShopifyVideo}" type="video/mp4" />
                                    Your browser does not support the video tag. I suggest you upgrade your browser.
                                    </video>            
                                ` }}></div>


                            </div>
                        </div>
                    
                    </div>
                    
                </div>
            </section>
        
            <section className={tiendaStyles.platform}>


                <div className={tiendaStyles.platform_wrapper}>

                    <div className={tiendaStyles.platform_wrapper_title}>
                        <h3 className={headerStyles.header_titles_subtext}>Plataformas de comercio electrónico.</h3>
                    </div>

                    <div className={tiendaStyles.platform_wrapper_content}>

                        <div className={tiendaStyles.platform_wrapper_left}>
                            <Img fluid={data.imageEcommerce.childImageSharp.fluid} alt='Diseño de Ecommerce' css={css`width:90%`}/>

                        </div>
                        
                        <div className={tiendaStyles.platform_wrapper_right}>
                            
                            <p>Para el diseño y desarrollo de tiendas online utilizo dos de las principales plataformas de comercio electrónico.</p>
                            <p>Cada una de ellas ofrece una serie de ventajas. Según tu sector, el producto o servicio que ofrezcas, y tus necesidades, te asesoraré sobre cual plataforma de comercio electrónico se ajusta mejor a tu negocio.</p>

                            <div className={tiendaStyles.platform_wrapper_right_icons}><Shopify css={css` .st0{fill:#95BF47;} .st1{fill:#5E8E3E;} .st2{fill:#FFFFFF;} width: 40%`}/> <Webflow css={css` 
                                width: 40%; 
                                padding-right: 2rem;
                                
                                @media (max-width:600px){
                                    padding-right: 0;
                                }
                            `}/></div>

                        </div>
                    
                    </div>

                </div>
            </section>


            <section className={tiendaStyles.advantages}>
                <div className={tiendaStyles.advantages_wrapper_column}>

                    <div className={tiendaStyles.advantages}>
                        <h2 className={headerStyles.header_titles_text}>Ventajas de tener una tienda online<span className={headerStyles.header_titles_text_point}>.</span></h2>
                        <h3 className={headerStyles.header_titles_subtext}>Pónselo fácil a tus clientes.</h3>
                    </div>

                </div>

                <div className={tiendaStyles.advantages_cards}>

                        <div className={tiendaStyles.advantages_cards_steps}>
                            <Step1 />
                            <h3>Compra</h3>
                        </div>
                        <div className={tiendaStyles.advantages_cards_steps}>
                            <Step2  />
                            <h3>Envío</h3>
                        </div>
                        <div className={tiendaStyles.advantages_cards_steps}>
                            <Step3 />
                            <h3>Entrega</h3>
                        </div>
                </div>

                <div className={tiendaStyles.advantages_wrapper}>
                    <div className={tiendaStyles.advantages_wrapper_left}>
                        <ul>
                            <li><span>Abre las fronteras de tu negocio. Podrás llegar a clientes internacionales y escalar tu negocio.</span><FaCheckCircle /></li>
                            <li><span>Disponibilidad 24/7. Tus clientes podrán adquirir tus productos en cualquier momento.</span><FaCheckCircle /></li>
                            <li><span>Podrás ajustar los precios de venta y envío según la zona geográfica, país o peso del paquete.</span><FaCheckCircle /></li>
                            <li><span>Gestionar fácilmente tus pedidos gracias a la posibilidad de conectar con las principales empresas de envío.</span><FaCheckCircle /></li>
                            <li><span>Mostrar tu catálogo de productos fotografías de tus productos y descripciones detalladas y completas de tus productos.</span><FaCheckCircle /></li>
                            <li><span>Conectar tu catálogo de productos con Google Shopping, Facebook o Instagram Shopping.</span><FaCheckCircle /></li>
                            <li><span>Controla el inventario de tus productos, tanto para la venta online como para offline.</span><FaCheckCircle /></li>
                        </ul>
                    </div>
                    <div className={tiendaStyles.advantages_wrapper_right}>
                        <ul>
                            <li><span>Posibilidad de fidelizar a los clientes a través de la captación de datos e email marketing.</span><FaCheckCircle /></li>
                            <li><span>Base de datos de clientes con el histórico de pedidos.</span><FaCheckCircle /></li>
                            <li><span>Organizar fácilmente tu catálogo de productos de tu tienda online por categorías o colecciones.</span><FaCheckCircle /></li>
                            <li><span>Tener conocimiento de los productos más vendidos y los gustos de tus clientes.</span><FaCheckCircle /></li>
                            <li><span>Conocer la valoración de tus productos por parte de tus clientes. Muy útil para la toma de decisiones.</span><FaCheckCircle /></li>
                            <li><span>Reduce costes fijos de tu negocio.</span><FaCheckCircle /></li>
                        </ul>
                    </div>
                </div>
            </section>

        
        </Layout>
    )

}

export default IndexPage
